export default __webpack_public_path__ + "static/media/factory__9.fc5e40ed.jpg";